import React from 'react';
import ReactModal from "react-modal";
import style from "./style.module.scss";
import ButtonIcon from "../ButtonIcon/ButtonIcon";

function ConfirmationModal({ open, onClose, message, onConfirmClick, submitButtonText = "Confirm" }) {

  return (
    <ReactModal isOpen={open} className={style.react_modal}>
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.28033 3.21967C3.98744 2.92678 3.51256 2.92678 3.21967 3.21967C2.92678 3.51256 2.92678 3.98744 3.21967 4.28033L6.93934 8L3.21967 11.7197C2.92678 12.0126 2.92678 12.4874 3.21967 12.7803C3.51256 13.0732 3.98744 13.0732 4.28033 12.7803L8 9.06066L11.7197 12.7803C12.0126 13.0732 12.4874 13.0732 12.7803 12.7803C13.0732 12.4874 13.0732 12.0126 12.7803 11.7197L9.06066 8L12.7803 4.28033C13.0732 3.98744 13.0732 3.51256 12.7803 3.21967C12.4874 2.92678 12.0126 2.92678 11.7197 3.21967L8 6.93934L4.28033 3.21967Z"
              fill="#737278"
            />
          </svg>
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>{message}</h6>
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#E03B24"}
            textColor="#FFF"
            onClick={() => onConfirmClick()}
          >
            {submitButtonText}
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  );
}

export default ConfirmationModal;
